<template>
    <main id="login-page" class="max-width-container">
        <h1>Login</h1>
        <LoginForm
            :errors="errors"
            :success-message="
                store?.justRegistered ? 'Registration successful!' : ''
            "
            @submit-form="submitForm"
        />
    </main>
</template>

<script>
import { useUserStore } from "../../stores/userStore";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import LoginForm from "js/components/forms/LoginForm";
import { safeRedirectTarget } from "js/lib/redirect.js";

export default {
    name: "Login",
    components: {
        LoginForm,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            store: null,
        };
    },
    mounted() {
        this.store = useUserStore();
    },
    methods: {
        submitForm(data) {
            const target = safeRedirectTarget(this.$route.query?.redir);
            this.store
                .login(data.email, data.password)
                .then((status) => {
                    if (status) {
                        window.location.href = target;
                    } else {
                        this.errors = { email: ["Login failed."] };
                    }
                })
                .catch(this.handleResponseErrors);
        },
    },
};
</script>
